<template>
  <button type="button" class="sbtn btn-warn">
    <i class="fa-solid fa-circle-xmark"></i>
    Cancel
  </button>
</template>
